module.exports = __webpack_public_path__ + "img/service4.6bea0bc9.png";